/* eslint-disable @typescript-eslint/no-explicit-any */

import 'core-js/es6/reflect';
import 'core-js/es7/reflect';
import 'zone.js';

/**  Copyright 2019 Google Inc. All Rights Reserved.
 Use of this source code is governed by an MIT-style license that
 can be found in the LICENSE file at http://angular.io/license */

(window as any).process = {
  env: { DEBUG: undefined },
};
